import type { QueryClient, QueryKey } from '@tanstack/react-query';

export const TENANT_SECURE_QUERY_ROOT = ['secure', 'tenant'] as const;
export const PLATFORM_SECURE_QUERY_ROOT = ['secure', 'platform'] as const;

export function tenantSecureQueryKey(
  tenantId: string,
  memberId: string,
  ...segments: readonly unknown[]
) {
  return [...TENANT_SECURE_QUERY_ROOT, tenantId, memberId, ...segments] as const;
}

export function platformSecureQueryKey(
  operatorId: string,
  ...segments: readonly unknown[]
) {
  return [...PLATFORM_SECURE_QUERY_ROOT, operatorId, ...segments] as const;
}

export function clearSecureQueryCache(queryClient: QueryClient, root: QueryKey) {
  void queryClient.cancelQueries({ queryKey: root });
  queryClient.removeQueries({ queryKey: root });
}
